module.exports = __webpack_public_path__ + "bd1bb607a63c2363b941fefba70ae245.png";